import React from 'react';
import './Base.css';

export const Base = (props) => {
    const { children, wide } = props;

    return (
        <div id="base">
            <div className={`centerBox${wide ? ' wide' : ''}`}>
                {children}
            </div>
        </div>
    );
}
